import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const disableStackletBackups = (id: number): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'disable_backups' },
  });
